import PageItemWrapper, { IPageItemattributes } from '../page-item-wrapper/page-item-wrapper';
import IconNextPage from '../../../../../icons/icon-next-page/icon-next-page';
import Button from '../button/button';
import { IPaginationButtonProps } from '../../../../table.types';
import Icon from '../../../../../icons/icon/icon';

const Next: React.FC<IPaginationButtonProps> = ({ isActive, onClick }) => {
    const attributes: IPageItemattributes = { 'aria-label': 'Next »' }
    const classList: string[] = ['next'];
    if (!isActive) {
        attributes['aria-disabled'] = true;
        classList.push('disabled')
    }
    return (
        <PageItemWrapper {...attributes} classList={classList}>
            {isActive ? <Button
                onClick={onClick}
                label="Next »"
            >
                <Icon Component={IconNextPage} />
            </Button> : <span className="page-link" aria-disabled="true">
                <Icon Component={IconNextPage} disabled />
            </span>}
        </PageItemWrapper>
    )
}

export default Next;
